
import {
  defineComponent, onBeforeMount, reactive, watch,
} from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import Icone from '@/core/components/Icone.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import { IListaPaginadaMetaData } from '@/core/models/Consulta/IListaPaginada';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IPagination } from '@/core/models/AntDesign/IPagination';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import { EVinculoEmpresa } from '@/core/models/Enumeradores/EEVinculoEmpresa';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import storeSistema from '@/store/storeSistema';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { useGradeBase } from '@/core/composables/GradeBase';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import Card from '@/core/components/Tela/Card.vue';
import { ETipoTituloFinanceiro } from '@/models/Enumeradores/Financeiro/ETipoTituloFinanceiro';
import { EStatusTituloFinanceiro } from '@/models/Enumeradores/Financeiro/EStatusTituloFinanceiro';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import ServicoRelatorioFinanceiro from '@/servicos/Relatorios/ServicoRelatoriosFinanceiros';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { useTituloFinanceiroBase } from '@/composables/Financeiro/TituloFinanceiroBase';
import TotalizadorDecorado from '@/core/components/Tela/TotalizadorDecorado.vue';
import { ETipoRelatorioRentabilidadeEmpresa } from '@/models/Enumeradores/Relatorios/ETipoRelatorioRentabilidadeEmpresa';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import { IFiltrosRelatorioRentabilidadeEmpresa } from '@/models/Relatorios/Financeiro/RentabilidadeEmpresa/IFiltrosRelatorioRentabilidadeEmpresa';
import { IDadosRelatorioRentabilidadeEmpresa, IDadosRelatorioRentabilidadeEmpresaItem } from '@/models/Relatorios/Financeiro/RentabilidadeEmpresa/IDadosRelatorioRentabilidadeEmpresa';
import SelecionarTipoRelatorioRentabilidadeEmpresa from '@/components/Relatorios/Financeiro/SelecionarTipoRelatorioRentabilidadeEmpresa.vue';

export default defineComponent({
  name: 'RelatorioRentabilidadeEmpresa',
  components: {
    Icone,
    Card,
    MensagemSemDados,
    TituloPadrao,
    PreviewPdf,
    SelecionarDataInicialFinal,
    TotalizadorDecorado,
    SelecionarTipoRelatorioRentabilidadeEmpresa,
  },
  setup(props) {
    const servicoSistema = new ServicoSistema();
    const servicoRelatorioFinanceiro = new ServicoRelatorioFinanceiro();
    const {
      telaBase, obterPermissoes, preencherEmpresasDisponiveis, verificaConceitoParaApresentarEmpresas, apresentarMensagemErro,
      defineEmpresasSelecionadasComPermissao, filtrarPermissaoDadosUsuarioMultiEmpresas, apresentarMensagemAlerta,
      adicionarAtalho, removerAtalho, preencherDadosRota,
    } = useTelaBase();

    const { gradeBase } = useGradeBase();
    const { obterClasseStatus } = useTituloFinanceiroBase(props);

    const state = reactive({
      dataInicial: '01/01/2001',
      dataFinal: '10/01/2001',
      filtros: {} as IFiltrosRelatorioRentabilidadeEmpresa,
      filtrosUtilizados: {} as IFiltrosRelatorioRentabilidadeEmpresa,
      resultado: {} as IDadosRelatorioRentabilidadeEmpresa,
      itens: [] as IDadosRelatorioRentabilidadeEmpresaItem[],
      paginacao: {} as IPagination,
      paginacaoApi: { totalRegistros: 0, paginaAtual: 1 } as IListaPaginadaMetaData,
      timerRegistros: 0,
      totalRegistrosComMascara: '100',
      arquivosPdf: [] as IArquivoPdf[],
      mostrarFiltros: 0,
      mostrarFiltrosInteligentes: 1,
      mostrarTotalizadores: 0,
      mostrarItens: false,
      cacheAutomatico: {} as ISalvamentoAutomatico,
    });

    telaBase.apresentarEmpresas = false;
    function preencherColunas() {
      if (storeSistema.state.layoutMobile) {
        gradeBase.colunas = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
          },
          {
            title: 'Item', dataIndex: 'item', key: 'Item', position: 2, visible: true,
          },
        ];
      } else if (state.filtros.tipo === ETipoRelatorioRentabilidadeEmpresa.Diaria) {
        gradeBase.colunas = [
          {
            title: 'Data', dataIndex: 'dataFormatada', key: 'DataFormatada', position: 1, visible: true, align: 'center', width: 50,
          },
          {
            title: 'Receita', dataIndex: 'receita', key: 'Receita', position: 2, visible: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'Lucro Bruto', dataIndex: 'lucroBruto', key: 'LucroBruto', position: 3, visible: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'Lucro Líquido', dataIndex: 'lucroLiquido', key: 'LucroLiquido', position: 4, visible: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'Margem de Lucro', dataIndex: 'margemLucro', key: 'MargemLucro', position: 5, visible: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
      } else {
        gradeBase.colunas = [
          {
            title: 'Mês', dataIndex: 'mes', key: 'Mes', position: 1, visible: true, align: 'center', width: 50,
          },
          {
            title: 'Receita', dataIndex: 'receita', key: 'Receita', position: 2, visible: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'Lucro Bruto', dataIndex: 'lucroBruto', key: 'LucroBruto', position: 3, visible: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'Lucro Líquido', dataIndex: 'lucroLiquido', key: 'LucroLiquido', position: 4, visible: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
          {
            title: 'Margem de Lucro', dataIndex: 'margemLucro', key: 'MargemLucro', position: 5, visible: true, align: 'right', width: 100, customRenderRow: ECustomRenderRow.MascararFracionado,
          },
        ];
      }
    }

    function obterIdentificadorCache(): string {
      return `RELATORIO_RENTABILIDADE_EMPRESA_${storeSistema.getters.codigoUsuarioAutenticado()}`;
    }

    function salvarCache() {
      const identificador = obterIdentificadorCache();
      state.cacheAutomatico.data = UtilitarioData.obterDataAtual();
      state.cacheAutomatico.codigoEmpresa = state.filtros.empresa;
      state.cacheAutomatico.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
      state.cacheAutomatico.identificador = telaBase.identificadorRecurso;
      state.cacheAutomatico.dados = JSON.stringify(state.filtros);
      servicoSistema.salvamentoAutomaticoLocalStorage(`${identificador}`, state.cacheAutomatico);
    }

    async function recuperarCache() {
      const cacheRestaurado = await servicoSistema.obterSalvamentoAutomaticoLocalStorage(obterIdentificadorCache());
      if (UtilitarioGeral.valorValido(cacheRestaurado)) {
        const cache = JSON.parse(cacheRestaurado.dados);
        state.filtros = cache;
        state.dataInicial = cache.dataInicial;
        state.dataFinal = cache.dataFinal;
        state.mostrarFiltros = 1;
        state.mostrarFiltrosInteligentes = 0;
      }
    }

    async function buscarRelatorio() {
      telaBase.carregando = true;
      state.filtros.dataInicial = state.dataInicial;
      state.filtros.dataFinal = state.dataFinal;
      state.filtros.numeroPagina = state.paginacao.current;
      state.filtros.qtdRegistrosPagina = state.paginacao.pageSize;
      state.filtros.qtdTotalRegistros = state.paginacao.total;
      state.resultado = await servicoRelatorioFinanceiro.obterRentabilidadeEmpresa(state.filtros);
      state.filtrosUtilizados = UtilitarioGeral.clonarObjeto(state.filtros);
      salvarCache();
      preencherColunas();
      state.mostrarItens = true;
      state.itens = state.resultado.itens.dados;
      state.paginacaoApi = state.resultado.itens.metaData;
      state.mostrarFiltros = 0;
      state.mostrarFiltrosInteligentes = 0;
      state.mostrarTotalizadores = 1;
      telaBase.carregando = false;
    }

    async function alterarQuantidadeRegistroTotal(valor: any) {
      clearTimeout(state.timerRegistros);
      let totalRegistros = 100;
      state.timerRegistros = setTimeout(async () => {
        if (UtilitarioGeral.valorValido(valor)) {
          const limiteRegistros = UtilitarioMascara.removerMascaraNumero(valor);
          if (limiteRegistros > 0) {
            totalRegistros = limiteRegistros;
          }
        }
        state.paginacao.total = totalRegistros;
        state.totalRegistrosComMascara = UtilitarioMascara.mascararNumeroInteiro(totalRegistros);
        await buscarRelatorio();
      }, 600);
    }

    async function onPageChange(current: number, pageSize: number) {
      state.paginacao.current = current;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    async function onShowSizeChange(current: number, pageSize: number) {
      state.paginacao.current = 1;
      state.paginacao.pageSize = pageSize;
      await buscarRelatorio();
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.filtros.empresa);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarRelatorio();
    }

    function usarFiltroInteligente(filtro: number) {
      switch (filtro) {
        case 2:
          state.filtros.tipo = ETipoRelatorioRentabilidadeEmpresa.Diaria;
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, 1);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 1);
          break;
        case 3:
          state.filtros.tipo = ETipoRelatorioRentabilidadeEmpresa.Diaria;
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataInicial = UtilitarioData.adicionarMesNaData(state.dataInicial, 1);
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          state.dataFinal = UtilitarioData.adicionarMesNaData(state.dataFinal, 3);
          break;
        case 4: {
          state.filtros.tipo = ETipoRelatorioRentabilidadeEmpresa.Mensal;
          const mesAtual = UtilitarioData.obterMesInteiroData(UtilitarioData.obterDataAtual());
          const anoAtual = UtilitarioData.obterAnoData(UtilitarioData.obterDataAtual());
          if (mesAtual <= 6) {
            state.dataInicial = `01/01/${String(anoAtual)}`;
            state.dataFinal = `30/06/${String(anoAtual)}`;
          } else {
            state.dataInicial = `01/07/${String(anoAtual)}`;
            state.dataFinal = `31/12/${String(anoAtual)}`;
          }
          break;
        }
        case 5: {
          state.filtros.tipo = ETipoRelatorioRentabilidadeEmpresa.Mensal;
          const anoAtual = UtilitarioData.obterAnoData(UtilitarioData.obterDataAtual());
          state.dataInicial = `01/01/${String(anoAtual)}`;
          state.dataFinal = `31/12/${String(anoAtual)}`;
          break;
        }
        default:
          state.filtros.tipo = ETipoRelatorioRentabilidadeEmpresa.Diaria;
          state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
          state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
          break;
      }
      buscarRelatorio();
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo) {
      telaBase.carregando = true;
      if (!UtilitarioGeral.validaLista(state.itens)) {
        await buscarRelatorio();
      }
      const retornoRelatorio = await servicoRelatorioFinanceiro.obterArquivoRentabilidadeEmpresa(tipoArquivoRelatorio, state.filtrosUtilizados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    function limparFiltros() {
      state.filtros = {} as IFiltrosRelatorioRentabilidadeEmpresa;
      state.filtros.empresa = storeSistema.getters.codigoEmpresaOperacao();
      state.filtros.tipo = ETipoRelatorioRentabilidadeEmpresa.Diaria;
      state.dataInicial = UtilitarioData.obterPrimeiroDiaMesAtual();
      state.dataFinal = UtilitarioData.obterUltimoDiaMesAtual();
    }

    watch(() => storeSistema.state.layoutMobile, () => {
      preencherColunas();
    });

    onBeforeMount(async () => {
      preencherDadosRota();
      await obterPermissoes(ETipoPermissao.Dados);
      await preencherEmpresasDisponiveis();
      await defineEmpresasSelecionadasComPermissao();
      verificaConceitoParaApresentarEmpresas();
      recuperarCache();
      preencherColunas();
      limparFiltros();
      state.paginacao.total = 100;
      state.paginacao.showSizeChanger = true;
      state.paginacao.pageSize = 100;
      state.paginacao.current = 1;
      state.paginacao.pageSizeOptions = ['10', '50', '100', '500', '1000'];
    });

    return {
      state,
      props,
      window,
      ETipoTituloFinanceiro,
      EStatusTituloFinanceiro,
      EVinculoEmpresa,
      ETipoArquivo,
      ECustomRenderRow,
      ETipoRelatorioRentabilidadeEmpresa,
      UtilitarioMascara,
      UtilitarioData,
      UtilitarioDispositivo,
      storeSistema,
      telaBase,
      gradeBase,
      preencherColunas,
      onPageChange,
      onShowSizeChange,
      alterarQuantidadeRegistroTotal,
      adicionarAtalho,
      removerAtalho,
      atualizarSelecaoEmpresas,
      obterClasseStatus,
      buscarRelatorio,
      usarFiltroInteligente,
      imprimir,
    };
  },
});
